<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-industry"></i>&nbsp;{{titulo}}</h1>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="kt-portlet__body">
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="row">
					<div class="col-md-6" *ngFor="let x of listaMaqueta">
						<mat-card class="mat-elevation-z8 mt-3" *ngIf="x.id < 4">
							<mat-card-header>
								<mat-card-title>
									<i class="fas fa-wheat" *ngIf="x.id == 1"></i>
									<i class="fas fa-shoe-prints" *ngIf="x.id == 2"></i>
									<i class="fas fa-truck-loading" *ngIf="x.id == 3"></i>
									{{x.nombre}}
								</mat-card-title>
							</mat-card-header>
							<mat-divider></mat-divider>
							<mat-card-content>
								<div class="row mt-3">
									<ng-container *ngIf="x.estatusVerde == 1">
										<div class="col-md-4"><i class="fad fa-toggle-on on icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Encendido</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.estatusVerde == 0">
										<div class="col-md-4"><i class="fad fa-toggle-off on icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Apagado</h3>
										</div>
									</ng-container>
								</div>
								<div class="row">
									<ng-container *ngIf="x.estatusRojo == 1">
										<div class="col-md-4"><i class="fad fa-toggle-on off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Encendido</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.estatusRojo == 0">
										<div class="col-md-4"><i class="fad fa-toggle-off off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Apagado</h3>
										</div>
									</ng-container>
								</div>
								<div class="row">
									<ng-container *ngIf="x.id == 1 && x.errorGeneral != 0">
										<ng-container *ngIf="x.errorGeneral >= 1 && x.errorGeneral <=4">
											<div class="col-md-4">
												<img src="./assets/image/error-gif.gif" alt="">
											</div>
											<div class="col-md-6">
												<div class="col-md-2">
													<h3 class="mt-5">&nbsp;Fallo</h3>
												</div>
											</div>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="x.id == 2  && x.errorGeneral != 0">
										<ng-container *ngIf="x.errorGeneral >= 13 && x.errorGeneral <=16">
											<div class="col-md-4">
												<img src="./assets/image/error-gif.gif" alt="">
											</div>
											<div class="col-md-6">
												<div class="col-md-2">
													<h3 class="mt-5">&nbsp;Fallo</h3>
												</div>
											</div>
										</ng-container>
									</ng-container>
									<ng-container *ngIf="x.id ==3  && x.errorGeneral != 0">
										<ng-container *ngIf="x.errorGeneral >= 9 && x.errorGeneral <=12">
											<div class="col-md-4">
												<img src="./assets/image/error-gif.gif" alt="">
											</div>
											<div class="col-md-6">
												<div class="col-md-2">
													<h3 class="mt-5">&nbsp;Fallo</h3>
												</div>
											</div>
										</ng-container>
									</ng-container>

								</div>
							</mat-card-content>
						</mat-card>
						<mat-card class="mat-elevation-z8 mt-3" *ngIf="x.id == 4">
							<mat-card-header>
								<mat-card-title>
									<i class="fas fa-hand-holding-box"></i>
									{{x.nombre}}
								</mat-card-title>
							</mat-card-header>
							<mat-divider></mat-divider>
							<mat-card-content>
								<div class="row mt-3">
									<ng-container *ngIf="x.estatusVerde == 1">
										<div class="col-md-4"><i class="fad fa-toggle-on on icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Encendido</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.estatusVerde == 0">
										<div class="col-md-4"><i class="fad fa-toggle-off on icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Apagado</h3>
										</div>
									</ng-container>
								</div>
								<div class="row">
									<ng-container *ngIf="x.estatusRojo == 1">
										<div class="col-md-4"><i class="fad fa-toggle-on off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Encendido</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.estatusRojo == 0">
										<div class="col-md-4"><i class="fad fa-toggle-off off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Led Verde Apagado</h3>
										</div>
									</ng-container>
								</div>
								<div class="row">
									<ng-container *ngIf="x.motor == 1">
										<div class="col-md-4"><i class="fad fa-toggle-on off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Motor Encendido</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.motor == 0">
										<div class="col-md-4"><i class="fad fa-toggle-off off icon"></i></div>
										<div class="cold-md-6">
											<h3 class="mt-5">Motor Apagado</h3>
										</div>
									</ng-container>
								</div>
								<div class="row">
									<!--<div class="col-md-4" ><i class="fad fa-toggle-on off icon"></i></div>-->
									<ng-container *ngIf="x.id == 4 && x.error==5">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo en Motor</h3>
										</div>
									</ng-container>
									<br>
									<ng-container *ngIf="x.errorGeneral >= 6 && x.errorGeneral <= 8">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
								</div>
							</mat-card-content>
						</mat-card>
					</div>
				</div>
				<mat-divider class="mt-3"></mat-divider>
				<div class="row mt-3">
					<div class="col-md-6" *ngFor="let x of listaMaqueta">
						<mat-card class="mat-elevation-z8 mt-3">
							<mat-card-header>
								<mat-card-title>
									<i class="fas fa-wheat" *ngIf="x.id == 1"></i>
									<i class="fas fa-shoe-prints" *ngIf="x.id == 2"></i>
									<i class="fas fa-truck-loading" *ngIf="x.id == 3"></i>
									<i class="fas fa-hand-holding-box" *ngIf="x.id == 4"></i>
									Tipos de Fallo en : {{x.nombre}}
								</mat-card-title>
							</mat-card-header>
							<mat-divider></mat-divider>
							<mat-card-content class="mt-2">
								<div class="row" *ngIf="x.id == 1">
									<!--<div class="col-md-4" ><i class="fad fa-toggle-on off icon"></i></div>-->
									<ng-container *ngIf="x.errorGeneral == 1">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 2">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 3">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 4">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
								</div>
								<!--2-->
								<div class="row" *ngIf="x.id == 2">
									<!--<div class="col-md-4" ><i class="fad fa-toggle-on off icon"></i></div>-->
									<ng-container *ngIf="x.errorGeneral == 13">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral ==14">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 15">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 16">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
								</div>
								<!--3-->
								<div class="row" *ngIf="x.id == 3">
									<!--<div class="col-md-4" ><i class="fad fa-toggle-on off icon"></i></div>-->
									<ng-container *ngIf="x.errorGeneral == 9">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 10">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 11">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 12">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
								</div>
								<!--4-->
								<div class="row" *ngIf="x.id == 4">
									<!--<div class="col-md-4" ><i class="fad fa-toggle-on off icon"></i></div>-->
									<ng-container *ngIf="x.errorGeneral == 6">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 7">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<h3 class="mt-5">&nbsp;Fallo</h3>
										</div>
									</ng-container>
									<ng-container *ngIf="x.errorGeneral == 8">
										<div class="col-md-4">
											<img src="./assets/image/error-gif.gif" alt="">
										</div>
										<div class="col-md-6">
											<div class="col-md-2">
												<h3 class="mt-5">&nbsp;Fallo</h3>
											</div>
										</div>
									</ng-container>
								</div>
							</mat-card-content>
						</mat-card>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
